/**
 * Safe helpers for reading Gemini generateContent responses.
 */

import type { GenerateContentResult } from "firebase/ai";

export type SafeResponseText =
  | { ok: true; text: string }
  | { ok: false; blocked: boolean; message: string };

/** Read model text without throwing on safety blocks or empty candidates. */
export function safeResponseText(result: GenerateContentResult): SafeResponseText {
  try {
    const text = result.response.text();
    return { ok: true, text };
  } catch (err) {
    const message = err instanceof Error ? err.message : String(err);
    const blocked =
      message.includes("blocked") ||
      message.includes("blockReason") ||
      message.includes("Candidate was blocked");
    return { ok: false, blocked, message };
  }
}
